import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import { get } from 'lodash'
import { compose } from 'recompose'

import { FileThumb } from 'components/misc'
import { apiConfiguration, apiDownloadFile } from 'helpers/decorators/api'

const enhance = compose(apiConfiguration(), apiDownloadFile())

class ConfigurationFile extends PureComponent {
  static propTypes = {
    configuration: PropTypes.object.isRequired,
    formattedName: PropTypes.object,
    user: PropTypes.object,
    files: PropTypes.object.isRequired,
    configKey: PropTypes.string.isRequired,
    downloadedFile: PropTypes.string,
    inline: PropTypes.bool,
    onDownloadFile: PropTypes.func,
    onGetConfigurationValue: PropTypes.func,
    organizationId: PropTypes.number,
    isPublic: PropTypes.bool,
    withAuthCode: PropTypes.bool
  }

  componentDidMount() {
    this.handleRequestDownload()
  }

  handleRequestDownload = () => {
    // eslint-disable-next-line
    let { organizationId, configKey, isPublic, withAuthCode } = this.props

    if (isPublic) {
      organizationId = organizationId || 1
    }

    this.props
      .onGetConfigurationValue(configKey, organizationId, isPublic)
      .then(({ body = {} } = {}) => {
        !isPublic && !withAuthCode && this.props.onDownloadFile(body.fileUrl)
      })
  }

  handleOpenFile = (fileUrl, type) => {
    const { configuration, configKey } = this.props

    const name = get(
      configuration,
      `values[${configKey}].configurationKey.description`
    )
    const link = document.createElement('a')

    link.download = `${name}.${type}`
    link.target = '_blank'
    link.href = fileUrl
    document.body.appendChild(link)

    link.click()
  }

  render() {
    const {
      configuration,
      configKey,
      files,
      downloadedFile,
      formattedName,
      inline,
      isPublic,
      withAuthCode,
      user
    } = this.props
    const documentUrl = get(configuration, `values[${configKey}].fileUrl`)
    let documentUrlWithCode = documentUrl
    // const documentName = get(
    //   configuration,
    //   `values[${configKey}].configurationKey.description`
    // )
    const fileUrl = get(files[documentUrl], 'fileLocalUrl') || downloadedFile
    const type = get(files[documentUrl], 'type') || ''
    const loading = get(files[documentUrl], 'loading')
    const configFileStyles = inline ? { marginBottom: 0 } : { marginBottom: 20 }

    if (withAuthCode) {
      const prefix = documentUrlWithCode && documentUrlWithCode.includes('?')
        ? '&'
        : '?'

      documentUrlWithCode = `${documentUrlWithCode}${prefix}authorizationCode=${get(user, 'blobAccessAuthorizationCode')}`
    }

    return (
      <div style={configFileStyles}>
        {isPublic &&
          <a
            href={documentUrl}
            target="_blank"
            className="link underline text-smaller"
          >
            {formattedName}
          </a>}

        {withAuthCode &&
          <a
            href={documentUrlWithCode}
            target="_blank"
            className="link underline text-smaller"
          >
            {formattedName}
          </a>}

        {!isPublic &&
          !withAuthCode &&
          <div>
            {!fileUrl &&
              <span
                className="link underline text-smaller"
                onClick={this.handleRequestDownload}
              >
                {formattedName}
              </span>}

            <FileThumb
              type={type}
              fileUrl={fileUrl}
              originUrl={documentUrl}
              onClick={this.handleOpenFile}
              loading={loading}
              autodownload
              formattedName={
                <span
                  className="link underline text-smaller"
                  onClick={this.handleRequestDownload}
                >
                  {formattedName}
                </span>
              }
              simple
            />
          </div>}
      </div>
    )
  }
}

export default enhance(ConfigurationFile)
